import { useGetQueryValues } from './useGetQueryValues';
import { EFilterField } from '../../common/type';

export const useFilterByCampaignParams = () => {
  const [campaignIdValue, campaignGroupIdValue] = useGetQueryValues({
    fields: [EFilterField.SINGLE_CAMPAIGN, EFilterField.GROUP_CAMPAIGN],
  });

  const hasFilterByCampaign = Boolean(campaignIdValue || campaignGroupIdValue);

  return { hasFilterByCampaign };
};
